import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTab, MatTabContent, MatTabGroup } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';
import { AiIllustrationComponent } from '../../../shared/components/ai-illustration/ai-illustration.component';
import { AiAgentsComponent } from './ai-agents/ai-agents.component';
import { AiProvidersComponent } from './ai-providers/ai-providers.component';
import { AiWelcomeComponent } from './ai-welcome/ai-welcome.component';

@Component({
  imports: [
    AiAgentsComponent,
    AiIllustrationComponent,
    AiProvidersComponent,
    AiWelcomeComponent,
    MatIcon,
    MatTab,
    MatTabContent,
    MatTabGroup,
    TranslateModule,
  ],
  selector: 'app-artificial-intelligence',
  standalone: true,
  styleUrl: './artificial-intelligence.component.scss',
  templateUrl: './artificial-intelligence.component.html',
})
export class ArtificialIntelligenceComponent {}
